import { Badge, BadgeProps as ChakraBadgeProps } from '@chakra-ui/react';

import DisplayNames from './enums';

Badge.displayName = DisplayNames.Badge;

export type BadgeProps = ChakraBadgeProps;

/*
  @deprecated - Per conversation with AJ. Badge is actually more of a NumberIndicator.
  TODO: AJ will be thinking deep thoughts on a future naming convention.
*/
export default Badge;
